import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useFeedback = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    name: "", 
  });

  
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/feedback/list", filter)
      setItems(response.data.feedbacks);
      setTotal(response.data.total);
      return response.data.feedbacks
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/feedback/all", requestData)
      setItems(response.data.feedbacks);
      setTotal(response.data.total);
      return response.data.feedbacks
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/feedback/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (feedback, count) => {
    try {
      const requestData = {
        feedback: feedback,
        count: count,
      };

      const response = await automobyApi.post("/feedback/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/feedback/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          feedback_id: id
        };
        const response = await automobyApi.post(`/feedback/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const getFeedbackByCarId = async (id) => {
    try { 
      const requestData = {
        car_id: Number(id)
      };

      const response = await automobyApi.post("/feedback/one", requestData)
      return response.data.feedback
      
    } catch (error) {
      console.error("ერორი:" + error);
    }
  }

 

  const feedbackService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    getFeedbackByCarId: getFeedbackByCarId,
    remove: remove, 
  };

  return { feedbackService };
}